import React, { useState, useEffect, useRef } from "react";
import { Snackbar, Alert, Typography } from "@mui/material";
import { application } from "globals/endpoints";
import loggerFactory from "globals/logger/logger-factory";

const ControlServerComponent = () => {
  const prevServerDataRef = useRef([]);
  const [showAlert, setShowAlert] = useState(false);
  const [serverName, setServerName] = useState("");
  const [countdown, setCountdown] = useState(10);
  const currentDomain = window.location.hostname
    .toLowerCase()
    .match(/[a-z]/i)?.input;
  const ControlServer = () => {
    application
      .post("/rluLocation/getIp")
      .then((res) => {
        if (!res.data || !res.data.data) {
          loggerFactory.warn("Received null or invalid data from server");
          return;
        }

        const newServerData = res.data.data;
        const matchedServerDomain = newServerData.find(
          (server) => server.domainName.toLowerCase() === currentDomain
        );

        if (!matchedServerDomain) {
          loggerFactory.warn(
            `No matching server found for domain: ${currentDomain}`
          );
          return;
        }

        const prevMatchedServerDomain = prevServerDataRef.current.find(
          (server) => server.domainName.toLowerCase() === currentDomain
        );

        if (
          prevMatchedServerDomain &&
          prevMatchedServerDomain.server &&
          matchedServerDomain.server &&
          prevMatchedServerDomain.server !== matchedServerDomain.server
        ) {
          loggerFactory.warn(
            `Server status changed for ${currentDomain}, reloading`
          );
          setShowAlert(true);
          setCountdown(10);

          const countdownInterval = setInterval(() => {
            setCountdown((prev) => {
              if (prev === 1) {
                clearInterval(countdownInterval);
                window.location.reload();
              }
              return prev - 1;
            });
          }, 1000);
        }

        prevServerDataRef.current = newServerData;
        setServerName(matchedServerDomain.server);
      })
      .catch((error) => {
        console.error("Unable to get status from server", error);
        loggerFactory.error("Unable to get status from server", error);
      });
  };

  useEffect(() => {
    const configInterval = window.configInterval || 0;
    const intervalTime = configInterval * 60 * 1000;

    if (configInterval > 0) {
      ControlServer();
      const interval = setInterval(ControlServer, intervalTime);
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <>
      <Snackbar
        open={showAlert}
        autoHideDuration={10000}
        onClose={() => setShowAlert(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setShowAlert(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%", fontWeight: "bold", color: "black" }}
        >
          {`Our server has successfully shifted from ${
            serverName === "Main" ? "Local to Main" : "Main to Local"
          } Server.`}
          <br />
          <Typography
            component="span"
            sx={{ color: "#E53935", fontWeight: "bold" }}
          >
            Reloading in {countdown} seconds.....
          </Typography>
        </Alert>
      </Snackbar>
    </>
  );
};

export default ControlServerComponent;
